'use client';

import { useCallback, useState } from 'react';

interface UseQuantityControlProps {
  item: any;
  formQuantity: number;
  setValue: (name: string, value: number) => void;
}

export function useQuantityControl({
  item,
  formQuantity,
  setValue,
}: UseQuantityControlProps) {
  const [isMaxQuantity, setIsMaxQuantity] = useState(false);

  const increaseQuantity = useCallback(() => {
    const inventoryQuantity = item?.quantity;
    if (inventoryQuantity !== undefined && formQuantity >= inventoryQuantity) {
      setIsMaxQuantity(true);
      return;
    }
    setIsMaxQuantity(false);
    setValue('quantity', formQuantity + 1);
  }, [formQuantity, setValue, item]);

  const decreaseQuantity = useCallback(() => {
    if (formQuantity > 1) {
      setValue('quantity', formQuantity - 1);
      setIsMaxQuantity(false);
    }
  }, [formQuantity, setValue]);

  return {
    isMaxQuantity,
    increaseQuantity,
    decreaseQuantity,
  };
}
